import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState({});
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("viriks_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPerms(data.permissions || {});
    } catch (e) {
      localStorage.removeItem("viriks_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = (token, u) => {
    localStorage.setItem("viriks_token", token);
    setUser(u);
    loadMe();
  };

  const logout = () => {
    localStorage.removeItem("viriks_token");
    setUser(null);
    setPerms({});
  };

  const can = (module, action) => {
    if (!user) return false;
    if (user.role === "super_admin") return true;
    return (perms[module] || []).includes(action);
  };

  return (
    <AuthContext.Provider value={{ user, perms, loading, login, logout, can, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
